import axios from 'axios'
// 使用element-ui message做消息提醒
import {
  message
} from '../../static/message.js'
import store from '../store/index.js'
import router from '../router/index.js'
// 1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: 'https://yunzhixuanpro.fw366.cn/api/',
  //baseURL: 'https://yunzhixuanpro.fw366.cn/api',
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 10000
})
// 2.请求拦截器
const that = this
service.interceptors.request.use(config => {
  // 发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
  config.data = JSON.stringify(config.data) // 数据转化,也可以使用qs转换
  config.headers.client = 11
  config.headers = {
    'Content-Type': 'application/json', // 配置请求头
    'client': 11
  }
  // 注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.token = token // 如果要求携带在请求头中
  }
  return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  // 接收到响应数据并成功后的一些共有的处理，关闭loading等
  if (response.data.code == 401) {
    message.error('登录过期，请重新登录')
    localStorage.clear()
    store.commit('login', true);
  }
  if (response.data.code == -1) {
    message.error(response.data.msg)
    return false
  }
  if (response.data.code == 402) {
    message.error(response.data.msg)
    router.push('/personalCenter')
    localStorage.setItem('/personalCenter', url)
    return false
  }
  if (response.data.code == 403) {
    message.error(response.data.msg)
    store.commit('openVip', true);
  }
  return response.data
}, error => {
  /** *** 接收到异常响应的处理开始 *****/
  if (error) {

  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      message.error('服务器响应超时，请刷新当前页')
    }
    error.message = '连接服务器失败'
  }

  message.error(error.message)
  /** *** 处理结束 *****/
  // 如果不需要错误处理，以上的处理过程都可省略
  return Promise.resolve(error.response)
})
// 4.导入文件
export default service



// WEBPACK FOOTER //
// ./src/request/request.js